<template>
  <!-- menuItem通过递归组件自身来处理菜单项的无限递归，直到菜单不再包含子菜单为止。 -->
  <el-submenu v-if="isChild(menuItem)" :index="menuItem.path" popper-class="header-menu-popper" >
    <template slot="title">
      <i v-if="menuItem.meta.icon.startsWith('el')"  :class="menuItem.meta.icon"></i>
      <svg-icon
        v-else
        :iconClass="menuItem.meta.icon"
        :className="menuItem.meta.svgClass?menuItem.meta.svgClass:''">
      </svg-icon>
      <span slot="title">{{ menuItem.meta.title }}</span>
    </template>
    <menu-item
      v-for="child in menuItem.children"
      :key="child.path"
      :menuItem="child"
    ></menu-item>
  </el-submenu>
  <el-menu-item v-else-if="!menuItem.meta.isHide" :index="menuItem.path" :style="{'padding-left': menuItem.meta.indent + 'px'}">
    <i v-if="menuItem.meta.icon.startsWith('el')"  :class="menuItem.meta.icon"></i>
    <svg-icon
      v-else
      :iconClass="menuItem.meta.icon"
      :className="menuItem.meta.svgClass?menuItem.meta.svgClass:''">
    </svg-icon>
    <span slot="title">{{ menuItem.meta.title }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'menuItem',
  props: {
    menuItem: {
      type: Object,
      require: true,
    },
  },
  methods: {
    isChild (menuItem) {
      if (menuItem.meta.isHide) {
        return false;
      }
      if (menuItem.children && menuItem.children.length > 0) {
        return menuItem.children.some((c) => (c.meta && !c.meta.isHide));
      }
      return false;
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/layout/components/menuItem.vue